import { FunctionComponent, MouseEvent } from "react";
import { Star, StarOutline } from "@mui/icons-material";
import styles from "./FavoriteStar.module.css";

interface FavoriteStarProps {
  favorited: boolean;
  onClick: (e: MouseEvent) => void;
}

export const FavoriteStar: FunctionComponent<FavoriteStarProps> = ({
  favorited,
  onClick,
}) => {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClick(e);
  };

  return (
    <span
      className={styles.star}
      onClick={handleClick}
    >
      {favorited ? <Star fontSize="small" /> : <StarOutline fontSize="small" />}
    </span>
  );
};
